/* eslint-disable max-len */
import faq_message from "./message_faq_nl.js";
import privacy_message from "./message_privacy_nl.js";

export default {
  error: {
    apicall: 'Auf dem API-Server ist etwas schief gelaufen!',
    UserNotFoundException: 'Benutzer existiert nicht.',
    NotAuthorizedException: 'Falscher Benutzername oder falsches Passwort.',
    ChangePasswordNotAuthorizedException: 'Altes Passwort falsch.',
    LimitExceededException: 'Versuch Limit überschritten, bitte versuchen Sie es nach einiger Zeit.',
    UsernameExistsException: 'Es existiert bereits ein Konto mit der angegebenen E-Mail.',
    InvalidParameterExceptionPassword: 'Das Passwort stimmt nicht mit der Richtlinie überein: Das Passwort muss eine Länge größer oder gleich 8 haben.',
    InvalidPasswordExceptionLong: 'Das Passwort stimmt nicht mit der Richtlinie überein: Passwort ist nicht lang genug.',
    InvalidPasswordExceptionLower: 'Das Passwort stimmt nicht mit der Richtlinie überein: Das Passwort muss Kleinbuchstaben enthalten.',
    InvalidPasswordExceptionUpper: 'Das Passwort stimmt nicht mit der Richtlinie überein: Das Passwort muss Großbuchstaben enthalten.',
    InvalidPasswordExceptionNumeric: 'Das Passwort stimmt nicht mit der Richtlinie überein: Das Passwort muss numerische Zeichen enthalten.',
    InvalidPasswordExceptionSymbol: 'Das Passwort stimmt nicht mit der Richtlinie überein: Das Passwort muss mindestens eines der oben genannten Sonderzeichen enthalten.',
    similar: 'Ein Benutzer mit demselben Namen und demselben Geburtsdatum ist bereits vorhanden. Bitte geben Sie einen Kommentar ein, um ihn zu unterscheiden.',
    alreadyAssignedImei: 'IMEI bereits einem Fahrer zugewiesen.',
    NetworkingError: 'Hmm ... es sieht so aus als ob du nicht mehr mit dem Internet verbunden bist.',
  },
  accountMenu: {
    settings: 'Änderung des Passwortes',
    logout: 'Logout',
    language: 'Sprache',
    languageFr: 'Français',
    languageNl: 'Nederlands',
    languageDe: 'Deutsch',
    languageEn: 'English',
  },
  login: {
    welcome1: 'Willkommen im BRAKE Programm "Behaviour Recording and Assessment for RisKs Education".',
    welcome2: 'Bitte loggen Sie sich ein, um auf Ihre Daten zugreifen zu können.',
    email: 'Email',
    emailPlaceholder: 'E-Mail Adresse',
    password: 'Passwort',
    passwordPlaceholder: 'Passwort',
    rememberMe: 'Erinnere dich an mich',
    forgottenPassword: 'Passwort vergessen?',
    connect: 'Einloggen',
    connectBussy: 'Anmelden ...',
    definePassword: 'Passwort ändern',
    instructions: {
      title: 'Ihr neues Passwort muss mindestens enthalten:',
      characters: 'Zeichen',
      uppercase: 'Großbuchstabe',
      number: 'Nummer',
      symbol: 'Sonderzeichen',
    },
    definePasswordButton: 'Passwort ändern',
    definePasswordButtonBussy: 'Passwort ändern ...',
  },
  signup: {
    emailLabel: 'Email',
    emailPlaceholder: 'E-Mail Adresse',
    passwortLabel: 'Passwort',
    passwordPlaceholder: 'Erstelle ein Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Passwort bestätigen',
    confirmationCodeLabel: 'Bestätigungscode',
    confirmationCodePlaceholder: 'Bestätigungscode eingeben',
    confirmationCodeHelp: 'Bitte überprüfe deine Email auf den Code.',
    registerButton: 'Registrieren',
    registerBussy: 'Anmeldung ...',
    allreadyAccountQuestion: 'Haben Sie bereits ein VIAS BRAKE Konto?',
    connectHere: 'Hier einloggen',
    oldPasswordPlaceholder: 'Bitte geben Sie Ihr altes Passwort ein.',
    oldPasswordLabel: 'Altes passwort',
  },
  forgot: {
    reinitPassword: 'Passwort zurücksetzen',
    mailsent: 'Mail gesendet',
    anEmailHasBeenSent: 'Eine E-Mail wurde gesendet.',
  },
  menu: {
    title: {
      driversShort: 'Fahrer',
      drivers: 'Zugeordnete Fahrer',
      users: 'Admin-Dashboard',
      calendar: 'Kalender',
      contested: 'Streitigkeiten',
    },
  },
  adminDashboard: {
    tabs: {
      drivers: 'Fahrer',
      psychologists: 'Psychologen',
      admins: 'Administratoren',
    },
    users: {
      firstName: 'Vorname',
      lastName: 'Familienname',
      birthdate: 'Geburtsdatum',
      email: 'Email',
      comment: 'Bemerkung',
      search: 'Suche',
      new: 'Neu',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      confirmDeleteTitle: 'Sind Sie sicher, dass Sie löschen möchten?',
      deleteOk: 'Bestätigen',
      deleteCancel: 'Annullieren',
      clickEnterComment: 'Geben Sie einen Kommentar ein.',
    },
    drivers: {
      birthdate: 'Geburtsdatum',
      psychologist: 'Psychologe',
      imei: 'IMEI',
    },
    psychologist: {
      assigned: 'Anzahl der zugewiesenen Fahrer',
      drivers: 'fahrer',
    },
  },
  driverActions: {
    tabs: {
      calendar: 'Kalender',
      stats: 'Statistiken',
      errorManagement: 'Umkämpfte Geschwindigkeitsüberschreitungen',
      followUp: 'Ziele und Follow-up',
    },
  },
  calendar: {
    event: {
      plugged: 'Gerät ist angeschlossen',
      unplugged: 'Gerät nicht angeschlossen',
    },
    messages: {
      date: 'Datum',
      time: 'Zeit',
      event: 'Einsetzung',
      allDay: 'den ganzen Tag',
      week: 'Woche',
      work_week: 'Arbeitswoche',
      day: 'Tag',
      month: 'Monat',
      previous: 'vorig',
      next: 'nächste',
      yesterday: 'gestern',
      tomorrow: 'morgen',
      today: 'heute',
      agenda: 'tagebuch',
      more: 'mehr',
    },
  },
  driverSelection: {
    name: 'Name',
    birthdate: 'Geburtsdatum',
    lastConsultation: 'Letzte Konsultation',
    disconnected: 'Getrennt',
    constested: 'Umstritten',
    speeding: 'Überdrehzahlen',
  },
  contested: {
    date: 'Datum',
    driver: 'Fahrer',
    location: 'Platz',
    action: 'Aktion',
    errorType: 'Fehlertyp',
    errorReason: 'Rechtfertigung',
  },
  faq:{
    faq_message
  },
  privacy:{
    privacy_message
  },
  journeyDetails: {
    indexTitle: 'Reise {index} von {total}',
    speeding: 'Geschwindigkeit überschreitet',
    severityTitle: 'Ernst',
    severity: {
      noOverSpeed: 'Keine geschwindigkeitsüberschreitung',
      small: 'Klein',
      medium: 'Durchschnitt',
      large: 'Sehr ernst',
      xlarge: 'Grab',
    },
    speed: 'Geschwindigkeit',
    limit: 'Begrenzung',
    time: 'Zeit',
    duration: 'Dauer des segments',
    street: 'Straße',
    gps: 'GPS',
    reportError: 'Fehler melden',
    acceptError: 'Akzeptieren',
    rejectError: 'Ablehnen',
    overspeed: 'Überschüssige Geschwindigkeit',
    parameter: {
      start: 'Zeitpunkt der Abreise',
      end: 'Ankunftszeit',
      distance: 'Zurückgelegte Strecke',
      avgSpeed: 'Durchschnittsgeschwindigkeit',
      maxSpeed: 'Höchstgeschwindigkeit',
    },
    itemsSelected: '{value, plural, one {element ausgewählt} other {elemente ausgewählt}}',
  },
  contestDialog: {
    title: 'Geben Sie einen Fehler an',
    errorType: 'Fehlertyp',
    selectErrorType: 'Wählen Sie den Fehlertyp',
    errorTypes: {
      mapmatching: 'Falscher Kartenabgleich',
      cartography: 'Kartenfehler',
      speedlimit: 'Falsche Geschwindigkeitsbegrenzung',
      other: 'Andere',
    },
    reason: 'Rechtfertigung',
    forValidation: 'Zur Validierung',
    retour: 'Zurück',
  },
  stats: {
    period: {
      overall: 'Insgesamt',
      today: 'Heute',
      yesterday: 'Gestern',
      currentWeek: 'Diese woche',
      lastWeek: 'Letzte woche',
      currentMonth: 'Aktueller monat',
      lastMonth: 'Letzten monat',
    },
    behaviour: {
      accelerations: 'Abrupte Beschleunigungen',
      brakings: 'Harte Bremsung',
    },
    grouping: {
      dayly: 'Tages',
      weekly: 'Wöchentliche',
      monthly: 'Monats',
      dayOfWeek: 'Tage der Woche',
      hourOfDay: 'Stunden des Tages',
      groupOfHourOfDay: 'Gruppierte Stunden des Tages',
      limit: 'Durch geschwindigkeitsbegrenzung',
    },
    charts: {
      numberOfOverspeeds: 'Anzahl der Überschreitungen',
      numberOfEvents: 'Anzahl der Ereignisse',
      totalOverspeeds: {
        title: 'Gesamtzahl Überschreitungen',
      },
      overspeedsBySeverity: {
        title: 'Details Schwere',
      },
      totalOverspeedsBySeverity: {
        title: 'Gesamtzahl Schwere / Zeitraum',
      },
      behaviourChart: {
        title: 'Bremsungen / Beschleunigungen',
      },
    },
  },
  followUp: {
    buttons: {
      new: 'Neu',
      save: 'Speichern',
      cancel: 'Stornieren',
    },
    comment: 'Kommentare',
    commentPlaceholder: 'Bitte geben Sie hier die Fahrerkommentare ein.',
    objective: 'Ziele',
    objectivePlaceholder: 'Bitte stellen Sie die Ziele hier vor.',
  },
  'react-intl-formatted-duration': {
    duration: '{value} {unit}',
    longFormatting: '{minutes} {seconds}',
    timerFormatting: '{minutes}:{seconds}',
    daysUnit: '{value, plural, one {tag} other {tage}}',
    hoursUnit: '{value, plural, one {stunde} other {stunden}}',
    minutesUnit: '{value, plural, one {minute} other {minuten}}',
    secondsUnit: '{value, plural, one {sekunde} other {sekunden}}',
  },
};



// WEBPACK FOOTER //
// ./src/messages_de.js